export default __webpack_public_path__ + "static/media/InviteIcon.70d5b082.svg";